import React, { createContext, useState, useContext } from "react";

// Create the context
const AddressContext = createContext();

// Create a provider component
export const AddressProvider = ({ children }) => {
  const [selectedAddress, setSelectedAddress] = useState(null);

  return (
    <AddressContext.Provider value={{ selectedAddress, setSelectedAddress }}>
      {children}
    </AddressContext.Provider>
  );
};

// Custom hook to use the address context
export const useAddress = () => useContext(AddressContext);